const { toInt, toString } = require('@/functions/transform');

/**
 * @constructor
 */
const EposPromoImage = function () {
    this.ID = null;
    this.image = '';
    this.title = '';
};

EposPromoImage.prototype = {
    getHydrationMap() {
        return {
            ID: {
                field: ['ID', 'eposPromoImageID'],
                transform: toInt,
            },
            image: toString,
            title: {},
        };
    },
};

module.exports = EposPromoImage;
